// 工作台
export default {
  'workplace.welcome': '你好',
  'workplace.login-time': '上次登录时间',
  'workplace.login-address': '上次登录地点',
  'workplace.user': '用户',
  'workplace.actor': '聊客',
  'workplace.article': '文章'
}